import lexical, {
    $createParagraphNode,
    EditorConfig,
    ElementNode,
    LexicalEditor,
    LexicalNode,
    RangeSelection,
    SerializedElementNode,
    Spread
} from "lexical"
import {$createBannerNode, BannerType} from "../banner-plugin"
import {NodeKey} from "lexical/LexicalNode"
import {ColorPalette} from "../../../../../fields3/color-coding/color-coding"

export type SerializedBannerNode = Spread<
    {
        bannerType: BannerType
    },
    SerializedElementNode
>

export function getBannerStyles(bannerType: BannerType) {
    let colorNumber = 0
    switch (bannerType) {
        case BannerType.LIGHT_BLUE  : colorNumber = 6; break
        case BannerType.DARK_BLUE   : colorNumber = 20; break
        case BannerType.GREEN       : colorNumber = 10; break
        case BannerType.YELLOW      : colorNumber = 14; break
        case BannerType.ORANGE      : colorNumber = 15; break
        case BannerType.RED         : colorNumber = 16; break
        case BannerType.MAGENTA     : colorNumber = 3; break
        case BannerType.PURPLE      : colorNumber = 4; break
        case BannerType.BROWN       : colorNumber = 19; break
        case BannerType.GRAY        : colorNumber = 0; break
    }

    return {
        color           : gd.skin.colors.mainColor({
            colorNumber: colorNumber,
            corePalette: ColorPalette.CORE
        }),
        borderLeftColor : gd.skin.colors.mainColor({
            colorNumber: colorNumber,
            corePalette: ColorPalette.CORE
        }),
        backgroundColor : gd.skin.colors.paleBGColor({
            colorNumber: colorNumber,
            corePalette: ColorPalette.CORE
        })
    }
}

export class BannerNode extends ElementNode {

    __bannerType: BannerType

    constructor(bannerType: BannerType, key?: NodeKey) {
        super(key)

        this.__bannerType = bannerType
    }

    static getType(): string {
        return 'banner-node' // just unique string
    }

    static clone(node: BannerNode): BannerNode {
        return new BannerNode(node.__bannerType, node.__key)
    }

    static importJSON(serializedNode: SerializedBannerNode): BannerNode {
        return $createBannerNode(serializedNode.bannerType)
    }

    getType() {
        return this.__bannerType
    }

    exportJSON() {
        return { ...super.exportJSON(),
            type        : BannerNode.getType(),
            bannerType  : this.__bannerType
        };
    }

    createDOM(config: EditorConfig, editor: LexicalEditor): HTMLElement {
        const element = document.createElement('div')
        element.className = config.theme.banner

        const style = getBannerStyles(this.__bannerType)
        element.style.borderLeftColor = style.borderLeftColor
        element.style.backgroundColor = style.backgroundColor

        return element
    }

    updateDOM(_prevNode: unknown, _dom: HTMLElement, _config: EditorConfig): boolean {
        return false
    }

    // what happens when you enter at the end of node
    insertNewAfter(selection: RangeSelection, restoreSelection?: boolean): LexicalNode | null {
        const newBlock = lexical.$createParagraphNode()
        const direction = this.getDirection()
        newBlock.setDirection(direction)
        this.insertAfter(newBlock, restoreSelection)
        return newBlock
    }

    // what happens when you backspace at the beginning of node
    collapseAtStart(selection: RangeSelection): boolean {
        const paragraph = $createParagraphNode()
        const children = this.getChildren()
        children.forEach(child => paragraph.append(child))
        this.replace(paragraph)
        return true
    }
}